import React, { useContext, useEffect } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { AuthProvider } from "./Context/AuthContext";
import { Provider } from "react-redux";
import { Login } from "./container/auth/login";
import { Dashboard } from "./container/dashboard";
import { EmployeeIndex } from "./container/dashboard/employeemanagement";
import { EmployeeDeciplinaryCase } from "./container/dashboard/employeemanagement/disciplinarycase";
import { OrganizationIndex } from "./container/dashboard/organizationmanagement";
import { OrganizationRequestIndex } from "./container/dashboard/organizationmanagement/request";
import { HolidayIndex } from "./container/dashboard/holidaymanagement";
import { OfficeStructureIndex } from "./container/dashboard/officestructure";
import { PerformanceIndex } from "./container/dashboard/perfomancemanagement";
import { TrainingIndex } from "./container/dashboard/trainingmanagement";
import { TrainingThemeIndex } from "./container/dashboard/trainingmanagement/themeoftheweek";
import { ReportIndex } from "./container/dashboard/reportmanagement";
import { CreateEmployee } from "./container/dashboard/employeemanagement/employees/create_employee";
import { Provider as AlertProvider } from "react-alert";
import { AlertTemplate } from "./components/Alert";
import {
  InternalRoute,
  ExternalRoute,
  SpecialRoute,
} from "./components/Auth.route";
import { role } from "./Constants/constant";
import { Sidebar } from "./components/Sidebar";
import { EmployeeInactive } from "./container/dashboard/employeemanagement/employees/inactive_employee";
// import { EditEmployee } from "./container/dashboard/employeemanagement/employees/edit_employee";
import { EmployeeWhoIsOut } from "./container/dashboard/employeemanagement/employees/who_is_out";
import { SystemConfig } from "./container/dashboard/systemconfiguration";
import { SystemConfigEvent } from "./container/dashboard/systemconfiguration/event";
import { SystemConfigJobtitle } from "./container/dashboard/systemconfiguration/jobtitle";
import { SystemConfigLeave } from "./container/dashboard/systemconfiguration/leave";
import { CalendarIndex } from "./container/dashboard/calendar";
import { ViewAllMunch } from "./container/dashboard/trainingmanagement/view_all";
import { AddNew } from "./container/dashboard/trainingmanagement/add_new";
import { AddNewTheme } from "./container/dashboard/trainingmanagement/themeoftheweek/add_new";
import { ViewAllTheme } from "./container/dashboard/trainingmanagement/themeoftheweek/view_all";
import { EditMunch } from "./container/dashboard/trainingmanagement/edit_ml";
import { EditTheme } from "./container/dashboard/trainingmanagement/themeoftheweek/edit_tow";
import store from "./store";
import ViewDetails from "./container/dashboard/employeemanagement/modals/view_details";
import { Notification } from "./container/dashboard/notification";
import EditUser from "./container/dashboard/employeemanagement/employees/edit_employe";
import { ReportEmployee } from "./container/dashboard/reportmanagement/employee_list";
import { ReportRequest } from "./container/dashboard/reportmanagement/repuest_list";
import { ReportLeave } from "./container/dashboard/reportmanagement/leave_list";
import { ReportDisciplinary } from "./container/dashboard/reportmanagement/disciplinary_case_list";
import { EmployeeReview } from "./container/dashboard/perfomancemanagement/employee_review";
import { HistoryReview } from "./container/dashboard/perfomancemanagement/history_review";
import { EmployeeHistoryReview } from "./container/dashboard/perfomancemanagement/employee_review_history";
import { ActivityLog } from "./container/dashboard/activity";
import { reset_Password } from "./container/auth/reset_password";
import { forgot_Password } from "./container/auth/forget_password";
import { Id_Card } from "./container/dashboard/employeemanagement/employees/id_card";
import { First_Login } from "./container/auth/first_login";
import AuthVerify from "./common/Auth.verify";
import { AuthContext } from "./Context/AuthContext";
import { useAlert } from "react-alert";
import { SystemConfigSubcategory } from "./container/dashboard/systemconfiguration/subCategory/index";
import { OrganizationRequesExpenditure } from "./container/dashboard/organizationmanagement/request/expenditure/expenditure";
import { pendingOfficeRequests } from "./container/dashboard/pending";
import { pendingLeaveRequests } from "./container/dashboard/pending/leave_request";

function App() {
  const { logout, checkedSessionExp } = useContext(AuthContext);
  // const alert = useAlert();
  return (
    <AlertProvider
      template={AlertTemplate}
      timeout={10000}
      position={"bottom right"}
    >
      <BrowserRouter>
        <AuthProvider>
          <Provider store={store}>
            <Switch>
              <ExternalRoute exact path="/" component={Login} />
              <ExternalRoute
                exact
                path="/forgot-password/:token"
                component={reset_Password}
              />
              <ExternalRoute
                exact
                path="/reset-password"
                component={forgot_Password}
              />
              <ExternalRoute
                exact
                path="/first-time-login"
                component={First_Login}
              />
              {/* <ExternalRoute
                        exact
                        path="/dashboard/index"
                        component={Dashboard}
                    /> */}

              <InternalRoute>
                <Sidebar />
                <Switch>
                  <Route exact path="/dashboard/index" component={Dashboard} />
                  <Route
                    exact
                    path="/dashboard/employee"
                    component={EmployeeIndex}
                  />
                  <Route
                    exact
                    path="/dashboard/employee/view-details"
                    component={ViewDetails}
                  />
                  <Route
                    exact
                    path="/dashboard/employee/inactive"
                    component={EmployeeInactive}
                  />
                  <Route
                    exact
                    path="/dashboard/employee/who-is-out"
                    component={EmployeeWhoIsOut}
                  />
                  <Route
                    exact
                    path="/dashboard/employee/id-card"
                    component={Id_Card}
                  />

                  <Route
                    exact
                    path="/dashboard/calendar"
                    component={CalendarIndex}
                  />

                  {/* SpecialRoute  below*/}

                  {/* <Route
                      exact
                      path="/dashboard/employee/edit/:slug"
                      isPrivate
                      role={role.admin}
                      component={EditEmployee}
                    /> */}
                  <Route
                    exact
                    path="/dashboard/employee/edit/:slug"
                    isPrivate
                    role={role.admin}
                    component={EditUser}
                  />
                  <Route
                    exact
                    path="/dashboard/employee/disciplinary"
                    isPrivate
                    role={role.admin}
                    component={EmployeeDeciplinaryCase}
                  />
                  <Route
                    exact
                    path="/dashboard/organization"
                    isPrivate
                    role={role.admin}
                    component={OrganizationIndex}
                  />
                  <Route
                    exact
                    path="/dashboard/organization/request"
                    isPrivate
                    role={role.admin}
                    component={OrganizationRequestIndex}
                  />
                  <Route
                    exact
                    path="/dashboard/organization/request/expendiure/:expenditureId"
                    isPrivate
                    role={role.admin}
                    component={OrganizationRequesExpenditure}
                  />
                  <Route
                    exact
                    path="/dashboard/holiday"
                    isPrivate
                    role={role.admin}
                    component={HolidayIndex}
                  />
                  <Route
                    exact
                    path="/dashboard/office-structure"
                    component={OfficeStructureIndex}
                    isPrivate
                    role={role.admin}
                  />
                  <Route
                    exact
                    path="/dashboard/performance"
                    component={PerformanceIndex}
                    isPrivate
                    role={role.admin}
                  />
                  <Route
                    exact
                    path="/dashboard/performance/employee-review"
                    component={EmployeeReview}
                    isPrivate
                    role={role.admin}
                  />
                  <Route
                    exact
                    path="/dashboard/performance/history-review"
                    component={HistoryReview}
                    isPrivate
                    role={role.admin}
                  />
                  <Route
                    exact
                    path="/dashboard/performance/employee-history-review"
                    component={EmployeeHistoryReview}
                    isPrivate
                    role={role.admin}
                  />
                  <Route
                    exact
                    path="/notification"
                    component={Notification}
                    isPrivate
                    role={role.admin}
                  />
                  <Route
                    exact
                    path="/activity-logs"
                    component={ActivityLog}
                    isPrivate
                    role={role.admin}
                  />
                  <Route
                    exact
                    path="/dashboard/training"
                    component={TrainingIndex}
                    isPrivate
                    role={role.admin}
                  />
                  <Route
                    exact
                    path="/dashboard/training/view-munch"
                    component={ViewAllMunch}
                    isPrivate
                    role={role.admin}
                  />
                  <Route
                    exact
                    path="/dashboard/training/edit-munch/:id"
                    component={EditMunch}
                    isPrivate
                    role={role.admin}
                  />
                  <SpecialRoute
                    exact
                    path="/dashboard/training/add-munch"
                    component={AddNew}
                    isPrivate
                    role={role.admin}
                  />
                  <Route
                    exact
                    path="/dashboard/training/edit-theme/:id"
                    component={EditTheme}
                    isPrivate
                    role={role.admin}
                  />
                  <Route
                    exact
                    path="/dashboard/training/add-theme"
                    component={AddNewTheme}
                    isPrivate
                    role={role.admin}
                  />
                  <Route
                    exact
                    path="/dashboard/training/view-theme"
                    component={ViewAllTheme}
                    isPrivate
                    role={role.admin}
                  />
                  <Route
                    exact
                    path="/dashboard/training/theme-of-week"
                    component={TrainingThemeIndex}
                    isPrivate
                    role={role.admin}
                  />
                  <Route
                    exact
                    path="/dashboard/report"
                    component={ReportIndex}
                    isPrivate
                    role={role.admin}
                  />
                  <Route
                    exact
                    path="/dashboard/report/employee"
                    component={ReportEmployee}
                    isPrivate
                    role={role.admin}
                  />
                  <Route
                    exact
                    path="/dashboard/report/request"
                    component={ReportRequest}
                    isPrivate
                    role={role.admin}
                  />
                  <Route
                    exact
                    path="/dashboard/report/leave"
                    component={ReportLeave}
                    isPrivate
                    role={role.admin}
                  />
                  <Route
                    exact
                    path="/dashboard/report/disciplinary-case"
                    component={ReportDisciplinary}
                    isPrivate
                    role={role.admin}
                  />
                  <Route
                    exact
                    path="/dashboard/create-employee"
                    isPrivate
                    role={role.admin}
                    component={CreateEmployee}
                  />
                  {/* <Route
                      exact
                      path="/dashboard/employee/edit/:slug"
                      isPrivate
                      role={role.admin}
                      component={EditEmployee}
                    /> */}
                  <Route
                    exact
                    path="/dashboard/system-configuration"
                    isPrivate
                    role={role.admin}
                    component={SystemConfig}
                  />
                  <Route
                    exact
                    path="/dashboard/system-configuration/event"
                    isPrivate
                    role={role.admin}
                    component={SystemConfigEvent}
                  />
                  <Route
                    exact
                    path="/dashboard/system-configuration/jobtitle"
                    isPrivate
                    role={role.admin}
                    component={SystemConfigJobtitle}
                  />
                  <Route
                    exact
                    path="/dashboard/system-configuration/leave"
                    isPrivate
                    role={role.admin}
                    component={SystemConfigLeave}
                  />
                  <Route
                    exact
                    path="/dashboard/system-configuration/subcategory"
                    isPrivate
                    role={role.admin}
                    component={SystemConfigSubcategory}
                  />
                  <Route
                    exact
                    path="/dashboard/pending"
                    isPrivate
                    role={role.admin}
                    component={pendingOfficeRequests}
                  />
                  <Route
                    exact
                    path="/dashboard/pending/leave"
                    isPrivate
                    role={role.admin}
                    component={pendingLeaveRequests}
                  />
                </Switch>
              </InternalRoute>
            </Switch>
            {/* <AuthVerify logout={checkedSessionExp} /> */}
          </Provider>
        </AuthProvider>
      </BrowserRouter>
    </AlertProvider>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js